import FxWebSocket from "@/plugins/fxWebSocket";
import api from "@/service/api";
import ConfigureInfo from "@/connect/configureInfo";

const actions = {
  async initWebSocket({ dispatch, commit }) {
    const ws = new FxWebSocket();

    commit("SAVE_WS", ws);

    dispatch("subscribeAll");

    ws.websocketonmessage((data) => {
      dispatch("setWsData", data);
    });

    ws.websocketonclose(() => {
      console.log("Attempt to reconnect");
      dispatch("initWebSocket");
    });
  },
  setWsData({ dispatch, rootState }, data) {
    switch (data.channel) {
      case "new_price":
        dispatch("setNewPrice", data.contents);
        break;
      case "market_price":
        dispatch("setMarketPrice", data.contents);
        break;
      case "open_orders":
        if (
          data.id ===
          rootState.tradingPair.queryPairInfo.pair +
            "&" +
            rootState.user.address
        ) {
          dispatch("setOpenOrders", data.contents);
        }
        break;
      case "order_book":
        if (data.id === rootState.tradingPair.queryPairInfo.pair) {
          dispatch("orderBook/setOrderBook", data.contents);
        }
        break;
      case "trades":
        if (data.id === rootState.tradingPair.queryPairInfo.pair) {
          dispatch("trades/setTrades", data.contents);
        }
        break;
      case "position":
        if (
          data.id ===
          rootState.tradingPair.queryPairInfo.pair +
            "&" +
            rootState.user.address
        ) {
          dispatch("setPosition", data.contents);
        }
        break;
      case "line":
        if (
          data.id ===
          `${rootState.kLine.timeListActive.apiInterval}@${rootState.tradingPair.queryPairInfo.pair}`
        ) {
          dispatch("kLine/updateKLine", data.contents);
        }
        break;
      case "funding_rate":
        dispatch("setQueryFunding", data.contents);
        break;
      case "position_amount":
        dispatch("setPositionAmount", data.contents);
        break;
      case "open_order_amount":
        dispatch("setOpenOrderAmount", data.contents);
        break;
      default:
        return;
    }
    // }
  },
  // Reconnect again, call the api and subscribe
  async subscribeAll({ state, dispatch }) {
    await dispatch("getQueryPairData");

    dispatch("getQueryFunding");

    dispatch("getFundingRateRealTime");

    dispatch("setIntervalFundingRateRealTime");

    dispatch("getQueryChainSystemInfo", {
      pair: state.tradingPair.queryPairInfo.pair,
    });

    state.ws.websocketsend({
      type: "subscribe",
      channel: "market_price",
      id: "",
      chainId: ConfigureInfo.Marginx.chainId,
    });

    dispatch("orderBook/getQueryOrderBook", {
      pair: state.tradingPair.queryPairInfo.pair,
    });
    dispatch("trades/getList", {
      pair: state.tradingPair.queryPairInfo.pair,
    });
    dispatch("kLine/getInfo");

    if (state.user.address) {
      dispatch("getQueryOpenOrder", {
        address: state.user.address,
        pair: state.tradingPair.queryPairInfo.pair,
      });
      dispatch("getQueryPosition", {
        address: state.user.address,
        pair: state.tradingPair.queryPairInfo.pair,
      });

      dispatch("getQueryOrderHistory", {
        address: state.user.address,
        pair: state.tradingPair.queryPairInfo.pair,
        pageIndex: 1,
        pageSize: 10,
      });
      dispatch("getQueryTradeDetail", {
        address: state.user.address,
        pair: state.tradingPair.queryPairInfo.pair,
        pageIndex: 1,
        pageSize: 10,
      });
    }
  },

  // Get system parameters
  async getQueryChainSystemInfo({ commit }, opt) {
    const queryChainSystemInfoData = await api["queryChainSystemInfo"](opt);

    commit("SET_CHAIN_SYSTEM_INNFO", queryChainSystemInfoData);
  },
  setAddressUnsubscribe({ state }) {
    if (state.user.address) {
      state.ws.websocketsend({
        type: "unsubscribe",
        channel: "open_orders",
        id: state.tradingPair.queryPairInfo.pair + "&" + state.user.address,
        chainId: ConfigureInfo.Marginx.chainId,
      });

      state.ws.websocketsend({
        type: "unsubscribe",
        channel: "position",
        id: state.tradingPair.queryPairInfo.pair + "&" + state.user.address,
        chainId: ConfigureInfo.Marginx.chainId,
      });
    }
  },
  //  Cancel pair subscription
  setPairUnsubscribe({ state, dispatch }) {
    console.log("setUnsubscribe", state);
    state.ws.websocketsend({
      type: "unsubscribe",
      channel: "market_price",
      id: "",
      chainId: ConfigureInfo.Marginx.chainId,
    });
    state.ws.websocketsend({
      type: "unsubscribe",
      channel: "order_book",
      id: state.tradingPair.queryPairInfo.pair,
      chainId: ConfigureInfo.Marginx.chainId,
    });
    state.ws.websocketsend({
      type: "unsubscribe",
      channel: "trades",
      id: state.tradingPair.queryPairInfo.pair,
      chainId: ConfigureInfo.Marginx.chainId,
    });
    state.ws.websocketsend({
      type: "unsubscribe",
      channel: "open_orders",
      id: state.tradingPair.queryPairInfo.pair,
      chainId: ConfigureInfo.Marginx.chainId,
    });
    state.ws.websocketsend({
      type: "unsubscribe",
      channel: "position",
      id: state.tradingPair.queryPairInfo.pair,
      chainId: ConfigureInfo.Marginx.chainId,
    });
    state.ws.websocketsend({
      type: "unsubscribe",
      channel: "funding_rate",
      // id: state.tradingPair.queryPairInfo.pair,
      last_height: "",
      chainId: ConfigureInfo.Marginx.chainId,
    });

    dispatch("kLine/unsubscribe");
  },
};
export default actions;
